import { OptionLoading } from './Options.styles';

type LoadingOptionProps = {
  loadingText?: string;
};

export const LoadingOption = ({ loadingText = 'loading...' }: LoadingOptionProps) => {
  return <OptionLoading>{loadingText}</OptionLoading>;
};
